module.exports = __webpack_public_path__ + "static/media/grph_element_5.00552e18.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Layout/Features/grph_element_5.svg
// module id = 278
// module chunks = 2